// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as PathHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/PathHelpers.mjs";

var app_download_link = "https://porter.in/app";

function get_utm_param_with_value(param_value) {
  return "";
}

function get_utm_param_linked(param_value) {
  return app_download_link + "?";
}

function getUrlPathString(path_name) {
  var path = Js_string.split("?", path_name);
  var match = path.length;
  if (match !== 0) {
    return Js_string.replaceByRe(/\//g, "_", Caml_array.get(path, 0));
  } else {
    return Js_string.replaceByRe(/\//g, "_", path_name);
  }
}

function getDownloadLink(router) {
  var match = PathHelpers$PorterinUtils.getRoutePathList(router.pathname);
  if (match) {
    switch (match.hd) {
      case "" :
          if (!match.tl) {
            return get_utm_param_linked([
                        "website_sticky_ssr",
                        "sticky_top_organic",
                        "sticky_top_organic_home",
                        "website_sticky_top_organic_home",
                        ""
                      ]);
          }
          break;
      case "fare_estimate_mob" :
          if (!match.tl) {
            return get_utm_param_linked([
                        "website_sticky_ssr",
                        "sticky_bottom_organic",
                        "sticky_bottom_organic_fare_estimate",
                        "website_sticky_bottom_organic_fare_estimate",
                        ""
                      ]);
          }
          break;
      case "services" :
          var match$1 = match.tl;
          if (!match$1) {
            return get_utm_param_linked([
                        "website_sticky_ssr",
                        "sticky_bottom_organic",
                        "sticky_bottom_organic" + getUrlPathString(router.asPath),
                        "website_sticky_bottom_organic" + getUrlPathString(router.asPath),
                        ""
                      ]);
          }
          if (!match$1.tl) {
            return get_utm_param_linked([
                        "website_sticky_ssr",
                        "sticky_bottom_organic",
                        "sticky_bottom_organic" + getUrlPathString(router.asPath),
                        "website_sticky_bottom_organic" + getUrlPathString(router.asPath),
                        ""
                      ]);
          }
          break;
      default:
        
    }
  }
  return get_utm_param_linked([
              "website_sticky_ssr",
              "sticky_top_organic",
              "sticky_top_organic" + getUrlPathString(router.asPath),
              "website_sticky_top_organic" + getUrlPathString(router.asPath),
              ""
            ]);
}

function getDownloadData(router) {
  return {
          link_with_text: {
            text: "OPEN APP",
            target: getDownloadLink(router)
          },
          src_path: "/images/common/download-app-icon-v2.svg",
          class_name: undefined,
          alt_text: "Porter",
          text: "Install Porter",
          sub_text: "for seamless goods delivery",
          description: undefined
        };
}

var download_sticky = {
  text: "Install Porter",
  sub_text: "for seamless goods delivery",
  cta_text: "OPEN APP",
  icon: {
    path: "/images/common/app-icon-compressed.png",
    alt_text: "Porter App Icon"
  }
};

var download_sticky_track_order = {
  text: "We're better on the app!",
  sub_text: "Discover live-tracking, discounts, payment options, and more",
  cta_text: "Download",
  icon: {
    path: "/images/common/download-app-icon.svg",
    alt_text: "Porter App Icon"
  }
};

var download_section = {
  text: "Book your order with us on the app!",
  sub_text: "We are loved by 10,00,000 + customers for our service!",
  cta_text: "Download App",
  icon: {
    path: "/assets/download-app-icon-v2.svg",
    alt_text: "Porter App Icon"
  }
};

var download_card_mobile_menu = {
  text: "We are better on the app!",
  sub_text: "",
  cta_text: "Download Now",
  icon: {
    path: "TrackOrderVm.download_app_card_icon.src",
    alt_text: "Download app"
  }
};

var download_card_order_history = {
  text: "Unlock Your Full Order History on the Porter App!",
  sub_text: "",
  cta_text: "Download Now",
  icon: {
    path: "https://dom-content-vault-prod-cdn-assets.porter.in/download_app_d2ac3cc4d7/download_app_d2ac3cc4d7.svg",
    alt_text: "Download app"
  }
};

var download_app_mobile_menu = {
  src: "https://dom-content-vault-prod-cdn-assets.porter.in/download_app_d2ac3cc4d7/download_app_d2ac3cc4d7.svg",
  width: 132.0,
  height: 116.36,
  alt: "download app"
};

var download_card_track_order = {
  text: "We are better on the app!",
  sub_text: "",
  cta_text: "Download Now",
  icon: {
    path: "https://dom-content-vault-prod-cdn-assets.porter.in/download_app_d2ac3cc4d7/download_app_d2ac3cc4d7.svg",
    alt_text: "Download app"
  }
};

var heightShowFrom = 1200;

var heightShowFromHome = 400;

var heightShowFromFareTrucks = 375;

var heightShowFromFareBikes = 0;

export {
  app_download_link ,
  get_utm_param_with_value ,
  get_utm_param_linked ,
  getUrlPathString ,
  getDownloadLink ,
  getDownloadData ,
  download_sticky ,
  download_sticky_track_order ,
  download_section ,
  download_card_mobile_menu ,
  download_card_order_history ,
  download_app_mobile_menu ,
  download_card_track_order ,
  heightShowFrom ,
  heightShowFromHome ,
  heightShowFromFareTrucks ,
  heightShowFromFareBikes ,
}
/* No side effect */
